import * as model from "@/model/prd/productionReport/dayReport/DaySmeltingProductionQuality";
import { newEntityStoreHelper } from "@/store/common/entityModule";


function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.DaySmeltingProductionQuality(), newFilter)
    .withStates({
        idReport: 2,

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start   
    .withActions({
        Delete(context,entity) {
            var checkedItems = context.state["checkedItems"];
            if (checkedItems) {
                var params = 'id=' + checkedItems.join(',');    
                        
            }
            context.dispatch("api/delete", { //发送请求
                url: context.state.baseModuleUrl + ("/daySmeltingProductionQuality"+ "?" + params)
            }, { root: true })
                .then(function () { // doing search again
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Deleted!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, { root: true }).then(function () {
                        context.dispatch("api/get", {
                            url: context.state.baseModuleUrl + "/daySmeltingProductionQuality/findByCode/" + entity.code
                        }, { root: true })
                            .then(response => {
      
                                {
      
                                    context.commit('daySmeltingProductionQuality' + "/setRows", response.list, { root: true }); 
                                }
                            });
                    })
                });
      
      
      
        },
    }) 
    .buildStore()